import { Component, OnInit } from '@angular/core';
import { Observable, catchError, delay, firstValueFrom, map, of } from 'rxjs';

import { HttpErrorResponse } from '@angular/common/http';
import { AuthService } from 'libs/pnp-services/src/lib/auth/auth.service';
import { LoginService } from '../../core/services/login.service';
import { AuthErrors, AuthErrorService, IUserPhotoResponse, PnpUserService } from '@pn-plus/pnp-services';
import { IAuthModel } from 'libs/pnp-services/src/lib/auth/_models/auth.model';

@Component({
    selector: 'nrwl-registration-complete',
    templateUrl: './registration-complete.component.html',
    styleUrls: ['./registration-complete.component.scss']
})
export class RegistrationCompleteComponent implements OnInit {
    public isLoading: boolean;

    constructor(
        private authService: AuthService,
        private loginService: LoginService,
        private pnpUserService: PnpUserService,
        private authErrorService: AuthErrorService
    ) { }

    async ngOnInit() {
        this.setBusy(true);
        let authModel = this.authService.getAuthModel();
        authModel.error = AuthErrors.Success;
        if(authModel?.registrationResponse && !authModel?.registrationResponse.hasCompletedRegistration) {
            authModel = await firstValueFrom(this.completeRegistration(authModel));
            authModel = await firstValueFrom(this.loadUserPhoto(authModel));
            authModel = await this.loginService.storeBase64Avatar(authModel);
            this.authService.updateAuthModel(authModel);
        }
        if (authModel.type && authModel.loginPayload.tokenId) {
            await firstValueFrom(this.pnpUserService.completeInvitation(authModel.loginPayload.tokenId));
        }
        this.setBusy(false);
    }

    completeRegistration(authModel: IAuthModel): Observable<IAuthModel> {
        return this.pnpUserService.putHasCompletedRegistration()
            .pipe(
                catchError((errorResponse: HttpErrorResponse) => {
                    authModel.error = this.authErrorService.getErrorByType(errorResponse?.error?.type);
                    return of(null);
                }),
                map((response: any) => {
                    if(authModel.registrationResponse) {
                        authModel.registrationResponse.hasCompletedRegistration = true;
                    }
                    return authModel;
                })
            );
    }

    private loadUserPhoto(authModel: IAuthModel) {
        if (authModel.error) {
            return of(authModel);
        }

        return this.pnpUserService.getUserPhoto()
            .pipe(
                catchError((errorResponse: HttpErrorResponse) => {
                    authModel.error = this.authErrorService.getErrorByType(errorResponse?.error?.type);
                    return of(null);
                }),
                map((userPhotoResponse: IUserPhotoResponse | null) => {
                    if(userPhotoResponse){
                        authModel.userPhotoResponse = userPhotoResponse;
                    }
                    return authModel;
                })
            );
    }

    onLoginClicked() {
        this.setBusy(true);
        of(true).pipe(delay(300)).subscribe(() => 
            { 
                const authModel = this.authService.getAuthModel();
                this.loginService.redirectAuthorizedUser(authModel);
                this.setBusy(false);
            },
        );
    }

    setBusy(flag: boolean): void {
        this.isLoading = flag;
    }
}
